export default __webpack_public_path__ + "static/media/social.5e10f267.png";